import { Checkbox, Stack, Text } from "@fluentui/react";
import React from "react";
import { BreakpointType } from "../../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../../Container/ContainerStyles";
import { descriptionStyles, lgDescriptionStyles, lgTitleStyles, mdDescriptionStyles, mdTitleStyles, registerEvaluationRowCheckboxStyles, registerEvaluationRowContainerSelectedStyles, registerEvaluationRowContainerStyles, registerEvaluationRowInnerContainerSelectedStyles, registerEvaluationRowTextContainerStyles, smDescriptionStyles, smTitleStyles, titleStyles, xlDescriptionStyles, xlTitleStyles, xxlDescriptionStyles, xxlTitleStyles } from "../Styles/RegisterTrialEvaluationStyles";

export interface IRegisterEvaluationRowProps {
    title: string;
    description: string;
    selected: boolean;
    asCheckbox?: boolean;
    customTitleClassName?: string;
    customDescriptionClassName?: string;
    onChange: (selected: boolean) => void;
}

export const RegisterEvaluationRow: React.FC<IRegisterEvaluationRowProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            className={props.selected ? registerEvaluationRowContainerSelectedStyles : registerEvaluationRowContainerStyles}
            onClick={() => props.onChange(!props.selected)}
        >
            <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
                className={props.selected ? registerEvaluationRowInnerContainerSelectedStyles : undefined}
            >
                <Stack
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                    verticalFill

                    className={registerEvaluationRowTextContainerStyles}
                >
                    <Checkbox
                        styles={!props.asCheckbox ? registerEvaluationRowCheckboxStyles : undefined}
                        checked={props.selected}
                        onChange={() => props.onChange(!props.selected)}
                        checkmarkIconProps={{ iconName: !props.asCheckbox ? 'LocationDot' : 'CheckMark' }}
                    />
                    <Stack
                        verticalFill
                        verticalAlign="center"
                    >
                        <Text
                            className={
                                props.customTitleClassName ?
                                    props.customTitleClassName
                                :
                                    isSM ? 
                                        smTitleStyles : 
                                    isMD ? 
                                        mdTitleStyles :
                                    isLG ?
                                        lgTitleStyles :
                                    isXL ?
                                        xlTitleStyles :
                                    isXXL ?
                                        xxlTitleStyles
                                    :
                                        titleStyles
                            }
                        >
                            {props.title}
                        </Text>
                        <Text
                            className={
                                props.customDescriptionClassName ?
                                    props.customDescriptionClassName 
                                :
                                    isSM ? 
                                        smDescriptionStyles : 
                                    isMD ? 
                                        mdDescriptionStyles : 
                                    isLG ?
                                        lgDescriptionStyles :
                                    isXL ?
                                        xlDescriptionStyles :
                                    isXXL ?
                                        xxlDescriptionStyles
                                    :
                                        descriptionStyles
                            }
                        >
                            {props.description}
                        </Text>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};